import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Sizes } from "../styles";

const fadeInFadeOutOnScroll = ($) => {
	// fixed element we're controlling
	const fixedElement = $(".fade-in-fade-out-element")[0];
	if (!fixedElement) return;

	let mm = gsap.matchMedia();
	const isMobile = `(max-width: ${Sizes.screens.large})`;
	const isDesktop = `(min-width: ${Sizes.screens.large})`;

	// where the peekaboo effect starts at first element of content() and ends at last element of content()
	const startContent = $(".main__body > :first-child")[0];
	const endContent = $(".marketing-lead-generation-contact-form_wrapper")[0];

	// if theres a button inside of header block (with image) => controls when the fixedElement is set to appear
	// if no button is found, the header block itself is used as the trigger
	const triggerButton = $(".header-with-image__text__button")[0]
		? $(".header-with-image__text__button")[0]
		: $(".header-block")[0];

	// hover effect
	let hover = gsap.to(fixedElement, {
		scale: 1.1,
		paused: true,
		duration: 0.3,
	});

	const screenWidth = window.innerWidth || document.documentElement.clientWidth;

	if (screenWidth >= 1024 && fixedElement) {
		fixedElement.addEventListener("mouseenter", () => hover.play());
		fixedElement.addEventListener("mouseleave", () => hover.reverse());
	}

	// initially setting visibility back to visible (to avoid flash of content on load)
	gsap.set(fixedElement, { visibility: "visible" });

	// animation for the element
	const showAnim = gsap.from(fixedElement, {
		opacity: 0,
		scale: 0,
		paused: true,
	});

	// animation on desktop
	mm.add({ isDesktop }, () => {
		ScrollTrigger.create({
			trigger: triggerButton,
			start: "top top",
			endTrigger: endContent,
			end: "top bottom",
			scrub: true,
			onEnterBack: () => showAnim.play(),
			onEnter: () => showAnim.play(),
			onLeave: () => showAnim.reverse(),
			onLeaveBack: () => showAnim.reverse(),
		});
	});

	// animation on mobile
	mm.add({ isMobile }, () => {
		// first scrollTrigger to make the element appear after the button inside of the header block is no longer in viewport
		ScrollTrigger.create({
			trigger: triggerButton,
			start: "top top",
			end: "bottom bottom",
			scrub: true,
			onEnterBack: () => showAnim.reverse(),
			onEnter: () => showAnim,
			onLeave: () => {
				showAnim.play();
				setTimeout(() => {
					peekabooFunc();
				}, 1500);
			},
		});
	});

	// scrollTrigger that takes care of hiding the element when scrolling down and showing the element when scrolling up
	const peekabooFunc = () => {
		ScrollTrigger.create({
			trigger: startContent,
			start: "top+=1600px center",
			endTrigger: endContent,
			end: "top top",
			onUpdate: (self) => {
				self.direction === -1 ? showAnim.play() : showAnim.reverse();
			},
		});
	};

	mm.add({ isMobile }, () => {
		peekabooFunc();
	});
};

export default fadeInFadeOutOnScroll;
